module.exports = __webpack_public_path__ + "img/you.4f0517e9.png";